import { render, staticRenderFns } from "./prexc.vue?vue&type=template&id=0f355f07&"
import script from "./prexc.vue?vue&type=script&lang=js&"
export * from "./prexc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports